import './App.css';
import Allroute from './routes/Routes';
import React from 'react';                  // added new 


function App() {
  return (
    <div className="App">
      <Allroute/>
    </div>
  );
}

export default App;
